import {Ij} from "../od/engagements/indemnites/ij";
import {Unite} from "./unite";
import {NatureVoyage} from "./nature-voyage";
import {Referentiel} from "@domain/admin/referentiels/referentiel";
import {Vehicule} from "@domain/vehicule/vehicule";
import {ListItem} from "@domain/common/list-view/list-item";
import {TypeBareme} from "./TypeBareme";
import {Cumul} from "@domain/prestation/prest-cumul";

/**
 * Prestation associée à une indemnité d'un OD
 */
export class Prestation implements ListItem {
	/** Données */
	idPrestation: number;
	libelle: string;
	code: string;
	icone: string;
	type: TypePrestation;
	typeBareme: TypeBareme;
	devise: string;
	bareme: boolean;
	idDomainePrestation: number;
	unite: Unite;
	saisieTaxe: boolean;
	quantiteObligatoire: boolean;
	quantiteModifiable: boolean;
	quantiteDefaut: number;
	remarqueObligatoire: boolean;
	libelleRemarque: string;
	natureVoyage: NatureVoyage;
	montantUnitaireModifiable: boolean;
	libelleField1: string;
	field1Obligatoire: boolean;
	libelleField2: string;
	field2Obligatoire: boolean;
	genre: Genre;
	modeParticipant: ModeParticipants;
	idAppTva: number;
	compte: string;

	/** Trajets personnels */
	saveTrajet: boolean;

	/** Gestion des étapes */
	gestionEtapes: boolean;

	/** Géolocatlisation */
	geolocalisation: boolean;

	/** Etapes personnelles */
	etapesPersonnelles: boolean;

	/** Gestion des heures de la tournée */
	gestionTempsGlobale: boolean;

	/** Gestion des heures sur chaque étape de la tournée */
	gestionTempsDetaillee: boolean;

	/** Indicateur sur le déplafonnement */
	disableDeplaf: boolean;

	/* Transient */
	dateApplication: Date;
	quantiteOrigineCumulIndemnites: number;
	quantiteCumulIndemnites: number;
	montantCumulIndemnites: number;
	listeIndemnitesLinkedToOd: Array<Ij>;
	famille: Referentiel;
	vehicule: Vehicule;

	actif: boolean;
	typeRemboursement: number;
	domainePrestation: string;
	montant: number
	idTypePrest: number;
	nature: string;
	idFamille: number;
	typePrest: Referentiel;
	idLiasse: number;
	liasse: Referentiel;
	compteLibelle: string;
	attribut1: string = null;
	attribut2: string = null;
	attribut3: string = null;
	attribut4: string = null;
	remarque: string;
	prorataRemb: number;
	frequenceAutorisee: Frequence;
	quantiteAutorisee: number;
	typeAssociation: TypeAssociation;
	idCumul: number;
	imputationTR: boolean;
	justificatifObligatoire: boolean;
	pieceJointeObligatoire: boolean;
	justificatifDefaut: boolean;
	libelleJustificatif: string;
	libelleJustificatifObligatoire: boolean;
	prestCumul: Cumul;
	compteExterne: string;
	compteExterneLibelle: string;
	participation: boolean;
	idAppTvaBis: number;
	idPays: number;
	idPuissance: number;

	constructor(dto?: any) {
		if (dto) {
			Object.assign(this,dto);
		}
	}

	getKey(): number {
		return this.idPrestation;
	}
}

/**
 * Enumération des types de prestation
 */
export enum TypePrestation {
	/** Enumération **/
	REEL = 0,
	PLAFOND = 1,
	FORFAIT = 2
}

/**
 * Création d'un namespace pour ajouter des fonctions supplémentaires sur l'énuméré
 */
export namespace TypePrestation {

	/**
	 * Retourne le libellé du type de prestation
	 *
	 * @param prestationType
	 */
	export function traductionShort(prestationType: number): string {
		switch (prestationType) {
			case TypePrestation.REEL:
				return "ndf.prestation.typeRemboursement.REEL";
			case TypePrestation.PLAFOND:
				return "ndf.prestation.typeRemboursement.plafondShort";
			case TypePrestation.FORFAIT:
				return "ndf.prestation.typeRemboursement.forfaitShort";
			default:
				return '';
		}
	}

}

/**
 * Réceptions - Usage
 * Si "Réception", autorise la gestion des invités sur les NDF
 */
export enum Genre {
	STANDARD = ' ',
	RECEPTION = 'R',
	LOYER = 'L',
	PARTICIPATION = 'P',
	AVANTAGE_NATURE = 'A',
	HOTEL = 'H'
}

/**
 * Mode de gestion des participants
 */
export enum ModeParticipants {
	TOUS = 0,
	INTERNES = 1,
	EXTERNES = 2,
}

/**
 * Type de remboursement
 */
export enum TypeRemboursement {
	NON_REMBOURSABLE = 0,
	REMBOURSABLE = 1
}

/**
 * Fréquences
 */
export enum Frequence {
	AUCUNE = 0,
	QUOTIDIENNE = 1,
	HEBDOMADAIRE = 2,
	MENSUELLE = 3,
	ANNUELLE = 4,
	EVENEMENT = 5
}

/**
 * Type d'association
 */
export enum TypeAssociation {
	AUCUNE = 0,
	PRINCIPALE = 1,
	SECONDAIRE = 2,
}